import { provideContext } from "react-remote-resource";
import { useActiveCustomerId } from "containers/LoggedInView/Context";

export { useActiveCustomerId as useCustomerId } from "containers/LoggedInView/Context";

export const provideCustomerId = provideContext(useActiveCustomerId);
